import type React from 'react';

function BudbeeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 245.66 245.66"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Budbee Icon</title>

      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M131.53,83.6c-16.2,0-33.1,6.6-43.1,16.4l-1.7,1.6-2,2.2V0H51.93V241.4h32.8v-17.2l2,2.4,1.7,1.6c9.9,9.9,26.5,16.4,43.1,16.4,43.1,0,79.5-32.9,79.5-80.5s-36.5-80.5-79.5-80.5Zm-1.7,131.5c-28.1,0-48-23-48-50.9s19.9-51,48-51c31.5,0,48,23,48,51s-16.5,50.9-48,50.9Z"
          fill="inherit"
        />
        <rect width="245.66" height="245.66" fill="none" />
      </g>
    </svg>
  );
}

export default BudbeeIcon;
